import { baseApi } from '@/lib/api/baseApi';
import { suppliersEndpoints } from './suppliers.queries';

export const suppliersApi = baseApi.injectEndpoints({ endpoints: suppliersEndpoints });

export const {
  useGetAccountSuppliersQuery,
  useGetSupplierFormQuery,
  useCreateSupplierMutation,
  useUpdateSupplierMutation,
} = suppliersApi;
